import React, { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Field } from 'react-final-form'

import { Typography, CircularProgress, MenuItem, Button, Divider } from '@mui/material'
import { Box } from '@mui/system'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import FormRow from 'components/form/FormRow'
import SelectButtonInput from 'components/form/input/SelectButtonInput'
import SelectInput from 'components/form/input/SelectInput'
import TextInput from 'components/form/input/TextInput'
import { fieldHasError, requiredValidator } from 'components/form/input/validator'
import { PField, useFieldValue } from 'components/form/input/NestedField'
import ImageInput from 'components/form/input/ImageInput'
import ImageBox from 'components/basic/ImageBox'

import RodadaEntity from '../../../Rodada'
import InscricaoEntity from 'entity/Inscricao'
import ProdutosEntity from 'entity/Produto/components/ProdutoDynamicTable'
import TableOtherProducts from '../TableOtherProducts'
import { fetchArray } from "entity"
import DebugObjComp from 'components/DebugObjComp'
import SeletorMunicipios from 'entity/Municipio/components/SeletorMunicipios'

import termsConditions from 'util/terms-conditions.pdf'
import LanguageSelector from 'components/LanguageSelector'
import { useTranslation } from "react-i18next"
import RenderQuestoesSecundarias from 'entity/Rodada/components/RodadaForm/Questoes/RenderQuestoesSecundarias'
import ProdutoSelector from 'entity/Produto/components/ProdutoSelector'

// Utilitários de geração de dados de teste
function gerarCnpj() {
    let total_array = 8;
    let n = 9;
    let create_array = (total, numero) => Array.from(Array(total), () => Math.round(Math.random() * numero));
    let mod = (dividendo, divisor) => Math.round(dividendo - (Math.floor(dividendo / divisor) * divisor));
    let [n1, n2, n3, n4, n5, n6, n7, n8] = create_array(total_array, n);
    let n9 = 0;
    let n10 = 0;
    let n11 = 0;
    let n12 = 1;
    let d1 = n12 * 2 + n11 * 3 + n10 * 4 + n9 * 5 + n8 * 6 + n7 * 7 + n6 * 8 + n5 * 9 + n4 * 2 + n3 * 3 + n2 * 4 + n1 * 5;
    d1 = 11 - (mod(d1, 11));
    if (d1 >= 10) d1 = 0;
    let d2 = d1 * 2 + n12 * 3 + n11 * 4 + n10 * 5 + n9 * 6 + n8 * 7 + n7 * 8 + n6 * 9 + n5 * 2 + n4 * 3 + n3 * 4 + n2 * 5 + n1 * 6;
    d2 = 11 - (mod(d2, 11));
    if (d2 >= 10) d2 = 0;
    return `${n1}${n2}${n3}${n4}${n5}${n6}${n7}${n8}${n9}${n10}${n11}${n12}${d1}${d2}`;
}
function gerarCpf() {
    let total_array = 9;
    let n = 9;
    let create_array = (total, numero) => Array.from(Array(total), () => Math.round(Math.random() * numero));
    let mod = (dividendo, divisor) => Math.round(dividendo - (Math.floor(dividendo / divisor) * divisor));
    let [n1, n2, n3, n4, n5, n6, n7, n8, n9] = create_array(total_array, n);
    let d1 = n9 * 2 + n8 * 3 + n7 * 4 + n6 * 5 + n5 * 6 + n4 * 7 + n3 * 8 + n2 * 9 + n1 * 10;
    d1 = 11 - (mod(d1, 11));
    if (d1 >= 10) d1 = 0;
    let d2 = d1 * 2 + n9 * 3 + n8 * 4 + n7 * 5 + n6 * 6 + n5 * 7 + n4 * 8 + n3 * 9 + n2 * 10 + n1 * 11;
    d2 = 11 - (mod(d2, 11));
    if (d2 >= 10) d2 = 0;
    return `${n1}${n2}${n3}${n4}${n5}${n6}${n7}${n8}${n9}${d1}${d2}`;
}


function InscricaoPublicFormInter(props) {
    const { t } = props
    const [loading, setLoading] = useState(true)
    const { change } = props.form
    const [searchParams] = useSearchParams();
    const searchRodada = searchParams.get("rodada")
    const searchType = searchParams.get("type")

    const { uid, empresa, rodada, tipo, checkOutros } = props.values
    // eslint-disable-next-line react-hooks/exhaustive-deps, no-unused-vars
    const [options, setOptions] = useState([])

    // corrige erro do dialog
    const [produtosAdicionadosVenda, setProdutosAdicionadosVenda] = useFieldValue("empresa.produtosVenda")
    const [idsSelecionadosVenda, setIdsSelecionadosVenda] = useState([])
    const [produtosAdicionadosCompra, setProdutosAdicionadosCompra] = useFieldValue("empresa.produtosCompra")
    const [idsSelecionadosCompra, setIdsSelecionadosCompra] = useState([])

    const query = useCallback(async () => {
        if (searchRodada) {
            let query = await RodadaEntity.where("uid", "==", searchRodada)

            const result = await fetchArray(query.get())

            setOptions(["", ...result])
            change("rodada", result[0])
        }
        setLoading(false)
    }, [change, searchRodada])

    useEffect(() => {
        if (tipo === undefined) {
            if (searchType === "1") {
                change("tipo", "ÂNCORA")
            } else if (searchType === "2") {
                change("tipo", "FORNECEDOR")
            }
        }
        query()
    }, [change, query, searchType, tipo])
    let rodadaAceitaInscricao = rodada?.status === "ATIVO"
    if (rodada?.bloqueiaInscricaoPublica === "SIM") {
        rodadaAceitaInscricao = false
    }
    if (rodada?.limiteInscricaoPublica) {
        let now = new Date()
        let limite = new Date(rodada?.limiteInscricaoPublica)
        if (now > limite) {
            rodadaAceitaInscricao = false
        }
    }
    // Função para gerar dados de teste
    const gerarTeste = useCallback(() => {
        let name = "Inscri " + new Date().toISOString();
        change("empresa.cnpj", gerarCnpj());
        change("empresa.nomeFantasia", name);
        change("empresa.nomeEmpresaCracha", name);
        change("empresa.descricaoEmpresa", "Descri - " + name);
        change("empresa.funcionarios.cpf", gerarCpf());
        change("empresa.funcionarios.nomeParticipante", "Func Nome - " + name);
        change("empresa.funcionarios.celular", '67999999999');
        change("termo", true);
    }, [change])

    let containsLink = /(http|https):\/\/[^\s/$.?#]+.[^\s]*/.test(rodada?.descricao)

    return <>
        {uid ?
            <Box sx={{ display: "flex", flex: 1, justifyContent: 'center', p: 3 }}>
                <Typography variant="h6">
                    {t('Inscrição realizada com sucesso!')}
                </Typography>
            </Box>
            :
            <>

                {rodada && tipo
                    ? <>
                        {rodadaAceitaInscricao ?

                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: 'center',
                                width: '100%',
                                maxWidth: { xs: '100%', sm: 700, md: 900 },
                                mx: 'auto',
                                px: { xs: 1, sm: 2, md: 4 },
                                py: { xs: 1, sm: 2 },
                                boxSizing: 'border-box',
                            }}>
                                {/* {console.log('rodada.capas', rodada.capas)} */}


                                {rodada.capa && <ImageBox

                                    sx={{ width: { xs: "100%", sm: "838px" }, paddingBottom: 1 }}

                                    maxWidth={'100%'}
                                    maxHeight={"50vh"}
                                    src={rodada.capa.base64}
                                    alt={"capa"}
                                />}
                                <Typography variant="h6">
                                    {rodada.nome.toUpperCase()}
                                </Typography>
                                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                    {rodada.local.toUpperCase()}
                                </Typography>
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    {containsLink
                                        ? rodada?.descricao.split(' ').map((word, index) => {
                                            if (/(http|https):\/\/[^\s/$.?#]+.[^\s]*/.test(word)) {
                                                return (
                                                    <a href={word} key={index} target="_blank" rel="noopener noreferrer">
                                                        {word}{' '}
                                                    </a>
                                                )
                                            } else {
                                                return <span key={index}>{word} </span>
                                            }
                                        })
                                        : rodada?.descricao
                                    }
                                </Typography>
                                <FormContent sx={{ m: { xs: 0, sm: 1 }, mt: { xs: 2, sm: 4 }, width: '100%' }}>
                                    {/* <Button onClick={gerarTeste}>Gerar Teste</Button> */}
                                    <LanguageSelector />
                                    <Typography variant="h6">{t('CADASTRO DA EMPRESA')}</Typography>
                                    {/* Info. Empresa */}
                                    <Box sx={{ p: 2, width: "100%" }}>

                                        <Typography
                                            variant="h6"
                                            sx={{ color: 'text.secondary' }}
                                        >
                                            {t('INFORMAÇÕES DA EMPRESA')}
                                        </Typography>


                                        <FormRow sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: 2, width: '100%' }}>
                                            <SelectInput
                                                sx={{ flex: 1, minWidth: { xs: '100%', sm: 200 } }}
                                                name="empresa.tipoPessoa"
                                                label="TIPO DE PESSOA"
                                                required={rodada.rodadaInternacional === "SIM" ? false : true}
                                            >
                                                <MenuItem value={"CNPJ"}>JURÍDICA</MenuItem>
                                                <MenuItem value={"CPF"}>FÍSICA</MenuItem>
                                            </SelectInput>
                                            <TextInput
                                                sx={{ flex: 1, minWidth: { xs: '100%', sm: 200 } }}
                                                name="empresa.cnpj"
                                                label={empresa?.tipoPessoa === "CPF" ? "PESSOA FÍSICA" : "PESSOA JURÍDICA"}
                                                mask={!empresa?.tipoPessoa || rodada.rodadaInternacional === "SIM"
                                                    ? ""
                                                    : empresa?.tipoPessoa === "CPF"
                                                        ? "000.000.000-00"
                                                        : "00.000.000/0000-00"
                                                }
                                                disabled={!empresa?.tipoPessoa ? true : false}
                                                required={rodada.rodadaInternacional === "SIM" ? false : true}
                                            />
                                            <TextInput sx={{ flex: 2 }} name="empresa.nomeFantasia" label={t("NOME COMERCIAL")} required />
                                            <TextInput sx={{ flex: 1.8 }} name="empresa.nomeEmpresaCracha" label={t("NOME DA EMPRESA NO CRACHÁ")} required
                                            />
                                        </FormRow>
                                        <FormRow sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: 2, width: '100%' }}>
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.razaoSocial"
                                                label={t("RAZÃO SOCIAL")}
                                            />
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.endereco"
                                                label={t("ENDEREÇO COMPLETO")}
                                            />
                                            <SeletorMunicipios sx={{ flex: 1 }} label={t("Município")} rodada={rodada} required />
                                        </FormRow>
                                        <FormRow sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: 2, width: '100%' }}>
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.descricaoEmpresa"
                                                label={t("BREVE DESCRIÇÃO DA EMPRESA (RESUMO DE ATUAÇÃO DE SUA EMPRESA)")}
                                                multiline
                                                required
                                            />
                                        </FormRow>
                                    </Box>

                                    {/* Contatos */}
                                    <Box sx={{ backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
                                        <Typography
                                            variant="h6"
                                            sx={{ color: 'text.secondary' }}
                                        >
                                            {t('CONTATOS')}
                                        </Typography>
                                        <FormRow>
                                            <TextInput sx={{ flex: 2 }} name="empresa.telComercial" label={t("TELEFONE COMERCIAL")} mask="(00) 0000-0000" />
                                            <TextInput sx={{ flex: 2 }} name="empresa.celular" label={t("CELULAR")} mask="(00) 90000-0000" />
                                        </FormRow>
                                        <FormRow>
                                            <TextInput sx={{ flex: 2 }} name="empresa.email" label={t("EMAIL")} type="email" />
                                        </FormRow>
                                        <FormRow>
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.facebook"
                                                label={t("FACEBOOK")}
                                            />
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.instagram"
                                                label={t("INSTAGRAM")}
                                            />
                                        </FormRow>
                                        <FormRow>
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.linkedin"
                                                label={t("LINKEDIN")}
                                            />
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.youtube"
                                                label={t("YOUTUBE")}
                                            />
                                        </FormRow>
                                        <FormRow>
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.site"
                                                label={t("SITE")}
                                            />
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.twitter"
                                                label={t("TWITTER")}
                                            />
                                        </FormRow>
                                    </Box>

                                    <Typography variant="h6">{t('PARTICIPANTE')}</Typography>
                                    {/* PARTICIPANTE */}
                                    <Box sx={{ p: 2, width: "100%" }}>
                                        <Typography
                                            variant="h6"
                                            sx={{ color: 'text.secondary' }}
                                        >
                                            {t('INFORMAÇÕES DO PARTICIPANTE')}
                                        </Typography>
                                        <FormRow>
                                            <TextInput
                                                sx={{ flex: 0.5 }}
                                                name="empresa.funcionarios.cpf"
                                                label="CPF"
                                                mask={rodada.rodadaInternacional === "SIM" ? "" : "000.000.000-00"}
                                                required={rodada.rodadaInternacional === "SIM" ? false : true}
                                            />
                                            <TextInput sx={{ flex: 2 }} name="empresa.funcionarios.nomeParticipante" label={t("NOME COMPLETO")} required />
                                        </FormRow>
                                        <FormRow>
                                            <TextInput sx={{ flex: 2 }} name="empresa.funcionarios.nomeCracha" label={t("NOME NO CRACHÁ")} />
                                        </FormRow>
                                        <FormRow>
                                            <SelectButtonInput
                                                name="empresa.funcionarios.sexo"
                                                label={t("SEXO")}
                                                options={["FEMININO", "MASCULINO", "OUTRO"]}
                                                optionsToString={[t("FEMININO"), t("MASCULINO"), t("OUTRO")]}
                                            />
                                        </FormRow>
                                    </Box>
                                    <Box sx={{ backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
                                        <Typography
                                            variant="h6"
                                            sx={{ color: 'text.secondary' }}
                                        >
                                            {t('CONTATOS')}
                                        </Typography>
                                        <FormRow>
                                            <TextInput
                                                sx={{ flex: 2 }}
                                                name="empresa.funcionarios.email"
                                                label={t('Email')}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                            />
                                        </FormRow>
                                        <FormRow>
                                            <TextInput sx={{ flex: 2 }} name="empresa.funcionarios.celular" label={t("CELULAR")} mask="(00) 90000-0000" required />
                                            <TextInput sx={{ flex: 2 }} name="empresa.funcionarios.telComercial" label={t("CONTATO TELEFÔNICO")} mask="(00) 0000-0000" />
                                        </FormRow>
                                    </Box>
                                    <RenderQuestoesSecundarias rodada={rodada} t={t} />
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Typography variant="h6">
                                            {t('PRODUTOS/SERVIÇOS')}
                                        </Typography>

                                        {(empresa.produtosVenda && empresa.produtosVenda.length) || (empresa.produtosCompra && empresa.produtosCompra.length)
                                            ? <></>
                                            : props.modified["empresa.produtosVenda"] || props.submitFailed
                                                ? <Typography sx={{ color: '#f00' }}>Requerido</Typography>
                                                : <></>
                                        }
                                    </Box>
                                    <FormRow sx={{ display: 'flex', justifyContent: 'space-around' }}>
                                        <ProdutoSelector
                                            name="empresa.produtosCompra"
                                            label={t("Produtos/Serviços que eu compro")}
                                            produtosPermitidos={rodada?.produtos}
                                        />

                                    </FormRow>
                                    <FormRow sx={{ display: 'flex', justifyContent: 'space-around' }}>
                                        <ProdutoSelector
                                            name="empresa.produtosVenda"
                                            label={t("Produtos/Serviços que eu vendo")}
                                            produtosPermitidos={rodada?.produtos}
                                        />
                                    </FormRow>
                                    {/* <FormRow sx={{ display: 'flex', justifyContent: 'space-around' }}>
                                        <Box sx={{ width: "100%" }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    p: 2,
                                                    width: "100%",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <ProdutosEntity
                                                    nome="empresa.produtosCompra"
                                                    descricaoDisabled
                                                    rodada={rodada}
                                                    rotulo={t("Produtos/Serviços que eu compro")}

                                                    // corrigindo erro
                                                    idsSelecionados={idsSelecionadosCompra}
                                                    setIdsSelecionados={setIdsSelecionadosCompra}
                                                    produtosAdicionados={produtosAdicionadosCompra}
                                                    setProdutosAdicionados={setProdutosAdicionadosCompra}
                                                />

                                            </Box>
                                        </Box>

                                        <Divider />

                                        <Box sx={{ width: "100%" }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    p: 2,
                                                    width: "100%",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <ProdutosEntity
                                                    nome="empresa.produtosVenda"
                                                    descricaoDisabled
                                                    rodada={rodada}
                                                    rotulo={t("Produtos/Serviços que eu vendo")}

                                                    // corrigindo erro
                                                    idsSelecionados={idsSelecionadosVenda}
                                                    setIdsSelecionados={setIdsSelecionadosVenda}
                                                    produtosAdicionados={produtosAdicionadosVenda}
                                                    setProdutosAdicionados={setProdutosAdicionadosVenda}
                                                />
                                            </Box>
                                        </Box>


                                        <Box sx={{ backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
                                            <div style={{ display: "flex", width: "100%" }}>
                                                <Field
                                                    name="checkOutros"
                                                    component="input"
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        const { checked } = e.target
                                                        change("checkOutros", checked)
                                                        change("status", checked ? "PENDENTE/INSCRICAO" : "INSCRITO")
                                                    }}
                                                />
                                                <Typography sx={{ ml: 1 }} >
                                                    {t('Sugerir Outros Produtos/Serviços')}
                                                </Typography>
                                            </div>
                                            {checkOutros && <TableOtherProducts fieldName="outrosProdutos" fieldLabel="Outros Produtos" />}
                                        </Box>

                                        {rodada.permiteFotosInscricao === "SIM" && <FormRow>
                                            <ImageInput name={"fotos"} label={'Fotos de Produtos'} maxQt={5} multiple>
                                                <FormRow>
                                                    <TextInput name="descricao" label="Descrição" multiline rows={4} />
                                                </FormRow>
                                            </ImageInput>
                                        </FormRow>}
                                    </FormRow> */}

                                    {/* TERMO DE CONSENTIMENTO (LGPD) */}
                                    <Box sx={{ p: 0, width: "100%" }}>
                                        {/* <Accordion expanded>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <Typography color="text.secondary">TERMO DE CONSENTIMENTO (LGPD)</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Box sx={{ overflowX: 'auto', maxWidth: '100%' }}>
                                                    <Typography sx={{ textAlign: "justify" }}>
                                                        INFORMO QUE OS SEUS DADOS PESSOAIS SERÃO UTILIZADOS PARA O CUMPRIMENTO DE OBRIGAÇÕES CONTRATUAIS, LEGAIS E REGULATÓRIAS DO SEBRAE EM RAZÃO DE SUAS ATIVIDADES, PARA A EXECUÇÃO DE SEUS PROGRAMAS E PRESTAÇÃO DE SERVIÇOS, PARA FOMENTAR, DESENVOLVER E MELHORAR SOLUÇÕES PARA EMPREENDEDORES E PEQUENOS NEGÓCIOS, PARA OFERECER PRODUTOS E SERVIÇOS QUE SEJAM DO SEU INTERESSE, PARA REALIZAR PESQUISAS COM OS CLIENTES QUE FORAM ATENDIDOS PELO SEBRAE E PARA REALIZAR A COMUNICAÇÃO OFICIAL PELO SEBRAE OU POR SEUS PRESTADORES DE SERVIÇO, POR TELEFONE, E-MAIL, SMS, WHATSAPP, ETC., BEM COMO AUTORIZO O COMPARTILHAMENTO DOS MEUS DADOS COM ENTIDADES PARCEIRAS DO SEBRAE E COM CONSULTORES CREDENCIADOS PARA AS MESMAS FINALIDADE ANTERIORMENTE ESPECIFICADAS. CASO VOCÊ QUEIRA CONHECER UM POUCO MAIS DE COMO O SEBRAE TRATA OS SEUS DADOS PESSOAIS, VOCÊ PODE ACESSAR O SEU PORTAL EM WWW.SEBRAE.COM.BR/LGPD, LÁ REUNIMOS UM CONJUNTO DE INFORMAÇÕES SOBRE COMO ESTAMOS ATUANDO COM OS DADOS PESSOAIS DE NOSSOS CLIENTES, COM FOCO EM SEGURANÇA E TRANSPARÊNCIA. POLÍTICA DE PRIVACIDADE: HTTPS://MINIO-CPE.SEBRAE.COM.BR/DOCUMENTO/POLITICA-PRIVACIDADE.PDF. AO ASSINAR O "ACEITE LGPD" MANIFESTO-ME DE FORMA INFORMADA, LIVRE, EXPRESSA E CONSCIENTE NO SENTIDO DE AUTORIZAR O SISTEMA SEBRAE A REALIZAR O TRATAMENTO DE MEUS DADOS PESSOAIS PARA AS FINALIDADES AQUI ESTABELECIDAS.
                                                    </Typography>
                                                </Box>
                                            </AccordionDetails>
                                        </Accordion> */}

                                        <Typography variant='h6'>{t('TERMO DE CONSENTIMENTO (LGPD – LEI GERAL DE PROTEÇÃO DE DADOS)')}</Typography>
                                        <Typography sx={{ textAlign: "justify" }}>
                                            {t('Aceite LGPD. Acesse e leia a')} <a href={termsConditions} target="_blank" rel="noreferrer">{t('Política Sebrae LGPD')}</a>
                                        </Typography>

                                        <PField
                                            name={"termo"}
                                            validate={requiredValidator}
                                        >
                                            {(fieldProps) => {
                                                const hasError = fieldHasError(fieldProps.meta);
                                                return (
                                                    <Box>
                                                        <Box sx={{ display: "flex", backgroundColor: "rgba(125,125,125,0.2)", p: 2, width: "100%" }}>
                                                            <Field
                                                                name="termo"
                                                                component="input"
                                                                type="checkbox"
                                                                required
                                                            />
                                                            <Typography sx={{ ml: 1 }}>{t('Declaro que li e aceito os termos e condições.')}</Typography>
                                                        </Box>
                                                        {hasError && <Typography sx={{ color: '#f00' }}>{fieldProps.meta.error}</Typography>}
                                                    </Box>
                                                );
                                            }}
                                        </PField>
                                    </Box>


                                    <div style={{ display: 'flex', justifyContent: 'center', flex: 1, width: '100%', gap: 8, flexWrap: 'wrap' }}>
                                        <Button
                                            fullWidth={window.innerWidth < 600}
                                            sx={{ maxWidth: { xs: '100%', sm: 300 } }}
                                            onClick={() => {
                                                props.form.submit()
                                            }}
                                        >
                                            {t('Inscrever-se')}
                                        </Button>
                                    </div>
                                </FormContent>
                            </Box>
                            :
                            <Box sx={{ display: "flex", flex: 1, justifyContent: 'center', p: 3 }}>
                                <Typography variant="h6">
                                    {t('Esta rodada não pode receber inscrições')}
                                </Typography>
                            </Box>
                        }
                    </>
                    : loading
                        ? <Box sx={{ display: 'flex', justifyContent: "center", mt: '4em' }}>
                            <CircularProgress />
                        </Box>
                        : <Box sx={{ flex: 1, m: 1, display: "flex", justifyContent: 'center' }}>
                            <Typography
                                sx={{ color: 'text.disabled' }}
                                variant="h6"
                            >
                                {!rodada && !tipo
                                    ? "Rodada e Tipo de Inscrição do link não foram encontrados"
                                    : rodada && !tipo
                                        ? "Tipo de Inscrição do link não foi encontrada"
                                        : "Rodada do link não foi encontrada"
                                }
                            </Typography>
                        </Box>
                }
            </>
        }
        <DebugObjComp colection={InscricaoEntity.collectionUID} uidObj={props.values.uid} values={props.values} />
        {/* <BotaoCriarInscricao change={change} rodada={rodada} /> */}
    </>
}

export default function InscricaoPublicForm() {
    const { t } = useTranslation()

    return (
        <DefaultEntityCrud
            EntityClass={InscricaoEntity}
            title={t("Inscrição")}
            routeForm="public-inscricao"
            backRoute=""
            afterSave={(values) => {
                InscricaoEntity.sendThankYouEmail(values)
            }}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}


        >
            {(props) => {
                return <InscricaoPublicFormInter t={t} {...props} />
            }}
        </DefaultEntityCrud>
    )
}